var fn = function( obj ){
var __t,__p='';
__p+='\n\nstruct SurfaceData\n{\n  vec3 albedo;\n  vec3 specular;\n  vec3 emission;\n  float smoothness;\n  float occlusion;\n  float alpha;\n};\n';
return __p;
};
fn.toString=fn;
module.exports = fn;